import { memo } from 'react'

import {
  Group,
  Image,
  type MantineStyleProps,
  Text,
  useMantineColorScheme,
} from '@mantine/core'
import { Link } from '@tanstack/react-router'

import labs_url from './labs.svg'

import classes from './Logo.module.css'

export const Logo = memo<{
  size: MantineStyleProps['h']
  as_link?: boolean
  with_name?: boolean
  className?: string
}>(function Logo({ size, as_link = false, with_name = false, className }) {
  const { colorScheme } = useMantineColorScheme()
  const isDark = colorScheme === 'dark'

  const body = (
    <Group align="center" gap="xs" className={className}>
      <Image
        src={labs_url}
        h={size}
        w={size}
        alt="Fission Labs™ Logo"
        style={{
          filter: isDark ? 'none' : 'invert(1)',
          transition: 'filter 0.2s ease',
        }}
      />
      {with_name && (
        <Text size="xl" lh="1">
          Tower
        </Text>
      )}
    </Group>
  )

  if (as_link) {
    return (
      <Link className={classes.link} to="/" aria-label="Tower Homepage">
        {body}
      </Link>
    )
  }
  return body
})
